// extracted by mini-css-extract-plugin
export default {"table":"personaTable_table__qWeMk"};